<template>
  <div>
    <el-dialog v-model="obj.dialogFormVisible" :close-on-click-modal="false" title="自选" :width="'500px'">
      <div>
        <el-space wrap>
          <el-tag type="warning" size="small" style="margin-bottom: 20px;">添加或删除后，请务必点击保存按钮</el-tag>
          <el-form-item label="">
            <el-input v-model="obj.searchValue" placeholder="个股 名称/代码" @input="handleInput" style="width: 250px"
              clearable>
              <template #prefix>
                <el-icon class="el-input__icon">
                  <search />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <div>
              <el-button type="primary" @click="handleFavorites">
                <el-icon class="el-input__icon">
                  <star />
                </el-icon>保存自选
              </el-button>
            </div>
          </el-form-item>
        </el-space>
      </div>
      <div style="width: 250px; max-height: 420px;" class='search-ul'>
        <div v-for="data in obj.filteredList" :key="data" class="search-li" @click="handleClick(data)">
          {{ data['name'] }} {{ data['symbol'] }}
        </div>
      </div>
      <div class="pt-16">
        <el-space v-for="data in obj.symbolList" :key="data">
          <el-form-item label="">
            <el-input v-model="data.name" :disabled="true" style="width:80px;color:red" />
            <el-button type="danger" @click="del(data)">删除</el-button>
          </el-form-item>
        </el-space>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, nextTick, $forceUpdate } from "vue";
import { useRouter, useRoute } from 'vue-router'
import { http, httpNoLoading } from '../util/http'
import { ElMessage } from 'element-plus'
import { zIndexUp, zIndexDown, zIndexTop, zIndexBottom } from '../util/base'
export default {
  props: {
    visible: {
      type: String,
      default: false
    }
  },
  setup(props) {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const route = useRoute()
    const obj = reactive({
      dialogFormVisible: props.visible,
      searchList: [],
      filteredList: [],
      searchValue: '',
      searchSymbol: '',
      symbolList: [],
    })

    // 页面传来的事件处理
    vueEvent.on('favoritesDialogVisible', (flag) => {
      obj.dialogFormVisible = flag
      resetView()
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      // console.log("onMounted")
      renderSelect()
      renderData()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      vueEvent.off('favoritesDialogVisible', () => { })
    })

    // 获取数据渲染搜索框
    const renderSelect = () => {
      let formData = new FormData()
      formData.append("category", "all")
      formData.append("page", 1)
      formData.append("limit", "10000")
      http({
        url: `/market`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data.data)
        obj.searchList = res.data.data.data
        // obj.searchList2 = [{ symbol: '999999', name: '上证指数' }, { symbol: '399001', name: '深证指数' }]
      })
    }

    // 获取自选列表数据
    const renderData = () => {
      http({
        url: '/favorites',
        method: 'post',
      }).then((res) => {
        // console.log(res.data.data)
        let symbolList = res.data.data.split(',')
        symbolList.forEach((item) => {
          let splitedItem = item.split(' ')
          if (splitedItem.length === 2) {
            obj.symbolList.push({ 'name': splitedItem[0], 'symbol': splitedItem[1] })
          }
        })
        // console.log(obj.symbolList)
      })
    }

    // 搜索框输入事件
    const handleInput = () => {
      if (obj.searchValue.trim() === '') {
        obj.filteredList = []
        return
      }
      obj.filteredList = obj.searchList.filter(item => item['name'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()) ||
        item['symbol'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()))
    }

    // 搜索结果点击事件
    const handleClick = (data) => {
      obj.searchValue = data['name']
      obj.searchSymbol = data['symbol']
      obj.filteredList = []

      let msg = ''
      obj.symbolList.forEach((item) => {
        if (item.name === data['name']) {
          msg = '已经被选过了'
        }
        if (obj.symbolList.length === 30) {
          msg = '最多选择30个'
        }
      })

      if (msg !== '') {
        ElMessage.error(msg)
        obj.searchValue = ''
        return
      }

      obj.symbolList.push(data)
    }

    // 删除品种
    const del = (data) => {
      obj.symbolList.forEach((item) => {
        if (item.name === data.name) {
          // console.log(item.name)
          obj.symbolList.splice(obj.symbolList.indexOf(item), 1)
        }
      })
    }

    // 保存自选列表
    const handleFavorites = () => {
      let formData = new FormData()
      var symbolList = []
      obj.symbolList.forEach((item) => {
        symbolList.push(item.name + " " + item.symbol)
      })
      // console.log(symbolList.join(","))
      formData.append("favorites", symbolList.join(","))
      httpNoLoading({
        url: `/favorites_update`,
        method: 'post',
        data: formData
      }).then((res) => {
        ElMessage.success("操作成功")
        obj.dialogFormVisible = false
        vueEvent.emit('favoritesDialogClose', '')
      })
    }

    // 重置画面
    const resetView = () => {
      // obj.searchList = []
      // obj.filteredList = []
      obj.searchValue = ''
      obj.searchSymbol = ''
      obj.symbolList = []
      renderData()
    }

    return {
      obj,
      renderSelect,
      handleInput,
      handleClick,
      del,
      handleFavorites
    }
  }
}
</script>
<style scoped>
.edit_dev>>>.el-transfer-panel {
  width: 300px;
}

.search-ul {
  position: absolute;
  left: 20px;
  top: 165px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}

.search-li {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}

.search-li:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
</style>
